/** hg-order's shapes, as this feature uses them: names for the generated types. */
import type { components } from "@/shared/api/order.schema";

type Schemas = components["schemas"];

export type OrderRow = Schemas["StaffOrderRowResponse"];
export type VisitBrief = Schemas["StaffVisitBrief"];
export type Escalation = Schemas["EscalationResponse"];
export type EscalationBrief = Schemas["EscalationBrief"];
export type QueueAction = Schemas["QueueAction"];
export type BoardCounts = Schemas["BoardCountsResponse"];
export type VisitCommission = Schemas["VisitCommissionResponse"];
export type StaffOrder = Schemas["StaffOrderResponse"];
/** What a specialist proposed about an order: more days of its course, or a new visit. */
export type Proposal = Schemas["ProposalResponse"];
export type ProposalStatus = Schemas["ProposalStatus"];
/** "Is the treatment finished?": asked of a client after their specialist ended a course early. */
export type CourseCheck = Schemas["StaffCourseCheckResponse"];
/** A file of an order, or an upload no order has yet. */
export type OrderFile = Schemas["OrderFileResponse"];
export type FileKind = Schemas["FileKind"];
/** A link to read a file through, good for ten minutes. */
export type FileLink = Schemas["FileLinkResponse"];
export type AssignedOrder = Schemas["AssignedResponse"];
export type Visit = Schemas["VisitResponse"];
export type VisitLine = Schemas["VisitLineResponse"];
export type OrderEvent = Schemas["OrderEventResponse"];
export type Assignment = Schemas["AssignmentResponse"];
export type Candidate = Schemas["CandidateResponse"];
export type CancelReason = Schemas["CancelReasonAdminResponse"];
export type Area = Schemas["AdminAreaResponse"];
export type OrderPatient = Schemas["OrderPatientResponse"];
export type PageInfo = Schemas["PageInfo"];
/** Something the top bar's search found: an order, a client or a specialist. */
export type SearchHit = Schemas["SearchHitResponse"];

export type OrderStatus = Schemas["OrderStatus"];
export type VisitStatus = Schemas["VisitStatus"];
export type VisitAction = Schemas["VisitAction"];
export type Mismatch = Schemas["Mismatch"];
export type AssignRequest = Schemas["AssignRequest"];
export type Channel = Schemas["OrderChannel"];
export type PaymentMethod = Schemas["PaymentMethod"];
export type OrderSort = Schemas["OrderSort"];
export type StuckSettings = Schemas["StuckVisitSettingsResponse"];
export type DispatchRun = Schemas["DispatchRunResponse"];
export type DispatchOffer = Schemas["DispatchOfferResponse"];
export type ClientSummary = Schemas["ClientSummaryResponse"];
export type VisitTrack = Schemas["VisitTrackResponse"];

/** Every status a visit can be asked for by, in the order a visit lives through them. */
export const VISIT_STATUSES = [
  "scheduled",
  "searching",
  "assigned",
  "en_route",
  "on_site",
  "completed",
  "cancelled",
  "unfulfilled",
] as const satisfies readonly VisitStatus[];

/** Where an order can have been made, in the order the filter lists them. */
export const CHANNELS = [
  "app",
  "web",
  "miniapp",
  "admin",
  "specialist",
  "api",
  "legacy",
] as const satisfies readonly Channel[];

export const PAYMENT_METHODS = [
  "cash",
  "card",
  "click",
] as const satisfies readonly PaymentMethod[];

/** What the list can be ordered by, in the order the choice lists them: a `-` is the largest first. */
export const ORDER_SORTS = [
  "-created_at",
  "created_at",
  "status_since",
  "-status_since",
  "-total",
  "total",
] as const satisfies readonly OrderSort[];

// ---- a visit's services changed by staff ----

export type AddableService = Schemas["AddableServiceResponse"];
export type AmendedVisit = Schemas["AmendedVisit"];
export type AmendmentPreview = Schemas["AmendmentPreviewResponse"];
export type AmendmentIssue = Schemas["AmendmentIssueResponse"];
export type StaffAmendment = Schemas["StaffAmendVisitRequest"];
export type LineChange = Schemas["LineChange"];

// ---- an order taken on the phone ----

export type ClientCard = Schemas["ClientCardResponse"];
export type Address = Schemas["AddressResponse"];
export type Patient = Schemas["PatientResponse"];
export type NewAddress = Schemas["CreateAddressRequest"];
export type NewPatient = Schemas["CreatePatientRequest"];
export type Catalog = Schemas["CatalogResponse"];
export type CatalogService = Schemas["CatalogService"];
export type Preview = Schemas["PreviewResponse"];
export type Issue = Schemas["IssueResponse"];
export type Selection = Schemas["StaffPreviewRequest"];
export type NewOrder = Schemas["StaffCreateOrderRequest"];
export type VisitWindow = Schemas["VisitWindowResponse"];
export type Gender = Schemas["Gender"];
